import React, { memo, useState } from 'react'
import styles from './teammember.module.scss'
import { useNavigate } from 'react-router-dom'
import { UtilityTeamMember } from '../../../../../model/utility-users/utility-team-member'
import { DeleteIcon, RefreshIcon } from '../../../../../assets/icons'
import ResendTeamMemberInviteDialog from './ResendTeamMemberInviteDialog'
import CancelTeamMemberDialog from './CancelTeamMemberInviteDialog'
import { hasPermission } from '../../../../../guards/common/authentification-functions'
import { UtilityPermissions } from '../../../../../model/permissions/permissions'

type Props = {
    user: UtilityTeamMember
    onClose: () => void
    triggerLoad? : () => void
}

const InvitedTeamMemberOptionsDialog: React.FC<Props> = memo((props: Props) => {
    const { onClose, user, triggerLoad } = props

    const [cancelTeamMemberOpen, setCancelTeamMemberOpen] = useState(false)
    const [resendTeamMemberOpen, setResendTeamMemberOpen] = useState(false)

    const navigate = useNavigate()


    const openCancelTeamMember = (e: any) => {
        e.stopPropagation();
        setCancelTeamMemberOpen(true);
    }

    const closeCancelTeamMember = () => {
        setCancelTeamMemberOpen(false)
        onClose()
    }
    
    const openResendTeamMember = (e: any) => {
        e.stopPropagation();
        setResendTeamMemberOpen(true);
    }

    const closeResendTeamMemberInvite = () => {
        setResendTeamMemberOpen(false)
        onClose()
    }


    return (
        <>
            <div className={styles.dialogBackdrop} onClick={onClose}/>
            <div className={styles.dialogContainer}>
                {hasPermission(UtilityPermissions.EditUtilityUser) && <button className={`standardButton ${styles.button}`} onClick={openResendTeamMember}>
                    <RefreshIcon />
                    Resend 
                </button>}
                {hasPermission(UtilityPermissions.DeleteUtilityUser) && <button className={`standardButton ${styles.button} ${styles.deleteButton} `} onClick={openCancelTeamMember}>
                    <DeleteIcon />
                    Cancel
                </button>}
            </div>            
            {
            cancelTeamMemberOpen && <CancelTeamMemberDialog onCloseDialog={closeCancelTeamMember} onTeamMemberDelete={onClose} user={user} />
            }            
            {
            resendTeamMemberOpen && <ResendTeamMemberInviteDialog onCloseDialog={closeResendTeamMemberInvite} onResendTeamMemberInvite={onClose} user={user} />
            }
        </>

    )
})

export default InvitedTeamMemberOptionsDialog